/*Import Estilo*/
import './index.scss';
import '../../../../css/global.css';
import '../../../../css/normalize.css';

/*Import Bibliotecas*/
import { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/*Import Componentes*/
import Cabecalho from '../../../../components/Cabecalho';
import Rodape from '../../../../components/Rodape';
import CookieAceite from '../../../../components/CookieAceite';
import BtnVoltar from '../../../../components/bntVoltar';

/*Import Requisição API*/
import api from '../../../../api';
import MenuLateral from '../../../../components/MenuLateral';

export default function AlterarEndereco() {
    const [id, setId] = useState('');
    const [cep, setCep] = useState('');
    const [logradouro, setLogradouro] = useState('');
    const [numero, setNumero] = useState('');
    const [complemento, setComplemento] = useState('');
    const [bairro, setBairro] = useState('');
    const [cidade, setCidade] = useState('');
    const [estado, setEstado] = useState('');
    const [tipo, setTipo] = useState('');

    const [texto, setTexto] = useState('');
    const [modalAberto, setModalAberto] = useState(false);
    const caixaDeDialogo = useRef(null);
    const navigate = useNavigate();
    const location = useLocation(); // Para acessar o estado da navegação
    const idEndereco = location.state?.idEndereco; // Obtém o id do endereço passado no estado

    useEffect(() => {
        caixaDeDialogo.current = document.getElementById('CaixaDeDialogo');
    }, []);

    const fecharModal = () => {
        if (caixaDeDialogo.current) {
            caixaDeDialogo.current.close();
        }
    };

    const mostrarModal = () => {
        if (caixaDeDialogo.current) {
            caixaDeDialogo.current.showModal();
        }
    };

    useEffect(() => {
        const buscarDadosUsuario = async () => {
            try {
                const response = await api.get('/usuario', { withCredentials: true });
                if (response.data.success) {
                    setId(response.data.user.id);
                }
            } catch (error) {
                console.error('Erro ao buscar dados do usuário:', error);
            }
        };

        buscarDadosUsuario();
    }, []);

    useEffect(() => {
        const buscarEndereco = async () => {
            if (!idEndereco) return; // Certifica-se de que o idEndereco está disponível
            console.log('Buscando endereço com ID:', idEndereco); // Adicione este log
            try {
                const response = await api.get(`/endereco/${idEndereco}`, { withCredentials: true });
                if (response.data.success) {
                    const { logradouro, numero, complemento, bairro, cidade, estado, cep, tipo } = response.data.endereco;
                    setLogradouro(logradouro);
                    setNumero(numero);
                    setComplemento(complemento);
                    setBairro(bairro);
                    setCidade(cidade);
                    setEstado(estado);
                    setCep(cep);
                    setTipo(tipo);
                } else {
                    console.error('Erro ao buscar o endereço:', response.data);
                }
            } catch (error) {
                console.error('Erro ao buscar endereço:', error);
            }
        };

        buscarEndereco();
    }, [idEndereco]);

    const buscarEnderecoPorCep = async (cep) => {
        if (cep.length !== 8) {
            setTexto('Por favor, insira um CEP válido com 8 dígitos.');
            mostrarModal();
            return;
        }
        try {
            const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
            const data = await response.json();
            if (data.erro) {
                setTexto('CEP não encontrado.');
                mostrarModal();
            } else {
                setLogradouro(data.logradouro || '');
                setBairro(data.bairro || '');
                setCidade(data.localidade || '');
                setEstado(data.uf || '');
            }
        } catch (error) {
            console.error('Erro ao buscar endereço:', error);
            setTexto('Erro ao buscar o endereço. Tente novamente mais tarde.');
            mostrarModal();
        }
    };

    const enviarAlterarEndereco = async (e) => {
        e.preventDefault();
        if (!cep.trim() || !numero.trim() || !tipo.trim()) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            setTexto('Por favor, preencha todos os campos.');
            mostrarModal();
            return;
        } else {
            alterarEndereco();
        }
    }

    const alterarEndereco = async () => {
        try {
            const endereco = {
                logradouro,
                numero,
                complemento,
                bairro,
                cidade,
                estado,
                cep,
                tipo
            };

            const response = await api.put(`/endereco/${idEndereco}`, endereco, { withCredentials: true }); // Método PUT para atualizar
            if (response.data.success) {
                setTexto('Endereço alterado com sucesso!');
                mostrarModal();
                navigate('/menu/perfil'); // Redireciona após a alteração
            }
        } catch (error) {
            setTexto('Erro ao alterar endereço. Tente novamente mais tarde.');
            window.scrollTo({ top: 0, behavior: 'smooth' });
            mostrarModal();
            console.error('Erro ao alterar endereço:', error);
        }
    };

    const mascaraCep = (valor) => {
        return valor
            .replace(/\D/g, '')
            .replace(/(\d{5})(\d{3})/, '$1-$2')
            .slice(0, 9);
    };

    return (
        <section className='container-principal-alterar-endereco'>
            <dialog id="CaixaDeDialogo" className={modalAberto ? 'open' : ''}>
                <div className='conteudo-dialog'>
                    <div className="dialog-texto">
                        <p>{texto}</p>
                        <button id="botao" onClick={fecharModal}>
                            Ok
                        </button>
                    </div>
                </div>
            </dialog>
            <Cabecalho />

            <CookieAceite />

            <main>

                <MenuLateral />

                <section className='conteudo-alterar-endereco'>
                    <div className='titulo-perfil'>
                        <h1><span>Perfil</span> &gt; Alterar de Endereço</h1>
                    </div>
                    <BtnVoltar />
                    <div className='perfil-alterar-endereco'>
                        <h2>Altere seu Endereço</h2>
                        <p>Atualize suas informações para uma experiência de compra mais rápida e precisa.</p>
                        <form className='form-alterar-endereco' onSubmit={enviarAlterarEndereco}>

                            <div className='linha-1-endereco'>
                                <div className='conteudo-cep'>
                                    <label className='lasbel-cep'>CEP: <span className='span-obrigatorio'>*</span></label>
                                    <div className='input-cep'>
                                        <img className='icon' src='/assets/image/iconEndereco/iconCep.svg' />
                                        <img className='iconBarra' src='/assets/image/iconEndereco/barra.svg' />
                                        <input
                                            type="text"
                                            value={cep}
                                            onChange={(e) => setCep(mascaraCep(e.target.value))}
                                            onBlur={() => buscarEnderecoPorCep(cep.replace(/\D/g, ''))}
                                            maxLength={8}
                                            placeholder="Digite o CEP"
                                        />
                                    </div>
                                </div>

                                <div className='conteudo-numero'>
                                    <label className='lasbel-numero'>Número: <span className='span-obrigatorio'>*</span></label>
                                    <div className='input-numero'>
                                        <img className='icon' src='/assets/image/iconEndereco/iconNumero.svg' />
                                        <img className='iconBarra' src='/assets/image/iconEndereco/barra.svg' />
                                        <input
                                            type="text"
                                            value={numero}
                                            onChange={(e) => setNumero(e.target.value)}
                                            placeholder="Digite o Nº"
                                        />
                                    </div>
                                </div>
                            </div>

                            <label>Logradouro:</label>
                            <div className='input-logradouro'>
                                <img className='icon' src='/assets/image/iconEndereco/iconLogradouro.svg' />
                                <img className='iconBarra' src='/assets/image/iconEndereco/barra.svg' />
                                <input
                                    type="text"
                                    value={logradouro}
                                    onChange={(e) => setLogradouro(e.target.value)}
                                    placeholder="Logradouro"
                                    disabled
                                />
                            </div>

                            <label>Bairro:</label>
                            <div className='input-bairro'>
                                <img className='icon' src='/assets/image/iconEndereco/iconBairro.svg' />
                                <img className='iconBarra' src='/assets/image/iconEndereco/barra.svg' />
                                <input
                                    type="text"
                                    value={bairro}
                                    onChange={(e) => setBairro(e.target.value)}
                                    placeholder="Bairro"
                                    disabled
                                />
                            </div>

                            <div className='linha-5-endereco'>
                                <div className='conteudo-cidade'>
                                    <label className='lasbel-cidade'>Cidade:</label>
                                    <div className='input-cidade'>
                                        <img className='icon' src='/assets/image/iconEndereco/iconCidade.svg' />
                                        <img className='iconBarra' src='/assets/image/iconEndereco/barra.svg' />
                                        <input
                                            type="text"
                                            value={cidade}
                                            onChange={(e) => setCidade(e.target.value)}
                                            placeholder="Cidade"
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div className='conteudo-estado'>
                                    <label className='label-estado'>Estado:</label>
                                    <div className='input-estado'>
                                        <img src='/assets/image/iconEndereco/iconEstado.svg' />
                                        <img className='iconBarra' src='/assets/image/iconEndereco/barra.svg' />
                                        <input
                                            type="text"
                                            value={estado}
                                            onChange={(e) => setEstado(e.target.value)}
                                            maxLength={2}
                                            placeholder="Estado"
                                            disabled
                                        />
                                    </div>
                                </div>
                            </div>
                            <label>Complemento:</label>
                            <div className='input-complemento'>
                                <img className='icon' src='/assets/image/iconEndereco/iconComplemento.svg' />
                                <img className='iconBarra' src='/assets/image/iconEndereco/barra.svg' />
                                <input
                                    type="text"
                                    value={complemento}
                                    onChange={(e) => setComplemento(e.target.value)}
                                    maxLength={255}
                                    placeholder="Digite o complemento (Opcional)"
                                />
                            </div>

                            <label>Tipo: <span className='span-obrigatorio'>*</span></label>
                            <div className='conteudo-tipo-endereco'>
                                <img className='icon' src='/assets/image/iconEndereco/iconTipo.svg' />
                                <img className='iconBarra' src='/assets/image/iconEndereco/barra.svg' />
                                <select value={tipo} onChange={(e) => setTipo(e.target.value)}>
                                    <option value="" disabled>Selecione o tipo de endereço</option>
                                    <option value="residencial">Residencial</option>
                                    <option value="comercial">Comercial</option>
                                </select>
                            </div>

                            <button className='bnt-alterar-endereco' type="submit">Alterar Endereço</button>
                        </form>
                    </div>

                </section>
            </main >

            <Rodape />

        </section >
    );
}
